var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-to-speech",on:{"click":function($event){return _vm.speak()}}},[_c('font-awesome-icon',{attrs:{"icon":"volume-up"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }